import React from 'react'

type Props = {
  countdown: number
  runOnFirstUpdate?: boolean
}

const useCountdownTimer = (props: Props) => {
  const [timer, setTimer] = React.useState(props?.runOnFirstUpdate ? props.countdown : 0)
  const [isCounting, setCounting] = React.useState(false)
  const resetTimer = () => setTimer(props.countdown)
  React.useEffect(() => {
    if (timer > 0) {
      if (!isCounting) setCounting(true)
      const interval = setInterval(() => {
        setTimer((time) => time - 1)
      }, 1000)
      return () => {
        clearInterval(interval)
      }
    } else {
      setCounting(false)
    }
  }, [timer, isCounting])
  return { timer, resetTimer, isCounting }
}

export default useCountdownTimer
